import { useRef } from 'react'
import { useNavigate } from 'react-router'
import { Tooltip } from '../ui/atoms/tooltip/Tooltip'
import { DetailedDossbotChat } from './types'

interface DossbotChatProps {
  chat: DetailedDossbotChat
  chatId?: string
}

/**
 * This is the home page for the Dossbot application.
 * It renders the CopilotKit and CopilotChat components with a sidebar listing all chats.
 */
export function DossbotLeftNavItem({ chat, chatId }: DossbotChatProps) {
  const navigate = useNavigate()
  const titleRef = useRef<HTMLDivElement>(null)
  const summaryRef = useRef<HTMLDivElement>(null)

  const handleChatClick = (chatId: string) => {
    navigate(`/dossbot/chat/${chatId}`)
  }

  const truncateText = (text: string, maxLength = 40) => {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
  }

  const summaryTooltipText = chat.summary && chat.summary.length > 40 ? chat.summary : ''
  const titleTooltipText = chat.title && chat.title.length > 30 ? chat.title : ''

  return (
    <div
      key={chat.id}
      className={`flex w-full cursor-pointer flex-col items-start justify-start rounded-sm px-3 py-1 hover:bg-gray-2 ${
        chatId === chat.id ? 'bg-gray-3' : ''
      }`}
      onClick={() => handleChatClick(chat.id)}
    >
      <Tooltip placement="right" title={titleTooltipText}>
        <div ref={titleRef} className="mb-1 text-sm font-medium text-gray-10">
          {truncateText(chat.title, 30)}
        </div>
      </Tooltip>
      <Tooltip placement="right" title={summaryTooltipText}>
        <div ref={summaryRef} className="text-xs text-gray-9">
          {truncateText(chat.summary ?? 'No Description')}
        </div>
      </Tooltip>
    </div>
  )
}
